import styled from 'styled-components';

export const ChannelSelectContainer = styled.div`
  background-color: #f6f7f9;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  padding: 24px;
  text-align: center;
`;

export const ChannelOptionsWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 24px;
  flex-wrap: wrap;
`;

interface ChannelOptionCardProps {
  isSelected?: boolean;
}

export const ChannelOptionCard = styled.div<ChannelOptionCardProps>`
  background-color: white;
  border: 1px solid ${({ isSelected }) => (isSelected ? '#0066cc' : '#e5e5e5')};
  border-radius: 4px;
  padding: 16px 24px;
  min-width: 200px;
  cursor: pointer;
  transition: border-color 0.2s ease;

  &:hover {
    border-color: #0066cc;
  }
`;
